'use strict';

var i18n = require('i18next');
var EditVpnUsers = require('actions/vpn/users/EditVpnUsers');
var FormView = require('actions/vpn/users/FormView');
var StaticView = require('actions/vpn/users/StaticView');

/**
 * Action configuration for the VPN enable/disable action component.
 */
module.exports = {
  title: i18n.t('vpn.users.title'),
  Model: EditVpnUsers,
  FormView: FormView,
  TextView: StaticView,
};
